import React from 'react'
import { Grid, Table, Tab} from 'semantic-ui-react'
import { Button, Label, Header, Segment} from 'semantic-ui-react'
import { getBets } from '../reducers/bets';
import { getUserPoints } from '../reducers/userPoints';
import { connect } from 'react-redux';
import PointsControl from './PointsControl';


const singleAnswer = (bet) => {
    if (!bet){
        return (<Segment>
            <div style={{ textAlign: 'center' }}>
            <Header color ='yellow'>Ecco la giocata dell'utente.</Header>
            <Table striped celled fixed>
            <tbody>
              <Table.Row >
              <Table.Cell >
                  Domanda non ancora giocata.
              </Table.Cell>
          </Table.Row>
          </tbody>
        </Table>
        </div>
      </Segment>) 
    }
    return (<Segment>
        <div style={{ textAlign: 'center' }}>
        <Header color ='yellow'>Ecco la giocata dell'utente.</Header>
        <Table striped celled fixed>
        <tbody>
          <Table.Row >
          <Table.Cell >
              <Grid columns = {2}>
              <Grid.Column textAlign='center' floated='left' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Risposta</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center'  width = "50%">
              {bet.answer?bet.answer:'Not available yet'}
              </Grid.Column>
              </Grid>
          </Table.Cell>
          <Table.Cell>
          <Grid columns = {2}>
              <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal  color = 'purple'>Scommessa</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.bet}                   
              </Grid.Column>
              </Grid>
          </Table.Cell>                     
          </Table.Row>
          <Table.Row>
          <Table.Cell>
          <Grid columns = {2}>
              <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Tipo di risposta</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center'>
              {bet.quote>0?
                <Label color = {'green'}>Esatta!</Label>
                : bet.quote == -1?
                <Label color = {'red'}>Sbagliata!</Label>
                  :   bet.quote == 0    ? 
                        <Label color = {'black'}>Black Answer!</Label>
                        : <Label color = {'purple'}>Not available yet!</Label>
              }  
              </Grid.Column>
              </Grid>
          </Table.Cell>                     
          <Table.Cell>
          <Grid columns = {2}>
            <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Guadagno</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.gain == null?
                'Not available yet'
                :bet.gain<0?bet.gain:bet.gain-bet.bet}  
              </Grid.Column>
          </Grid>
          </Table.Cell>
          </Table.Row>
          <Table.Row>
          <Table.Cell>
          <Grid columns = {2}>
              <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Punteggio prima</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.old_balance}
              </Grid.Column>
              </Grid>
          </Table.Cell>                     
          <Table.Cell>
          <Grid columns = {2}>
          <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Punteggio dopo</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.new_balance == null?
                'Not available yet'
                :bet.new_balance} 
              </Grid.Column>
          </Grid>
          </Table.Cell>                      
          </Table.Row>
          <Table.Row>
          <Table.Cell>
          <Grid columns = {2}>
              <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Posizione Vecchia</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.before_position == null?
                'Not available yet'
                : bet.before_position}
              </Grid.Column>
              </Grid>
          </Table.Cell>                     
          <Table.Cell>
          <Grid columns = {2}>
             <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Posizione Nuova</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.after_position == null?
                'Not available yet'
                :bet.after_position} 
              </Grid.Column>
          </Grid>
          </Table.Cell>
          </Table.Row>
          <Table.Row>
          <Table.Cell>
          <Grid columns = {2}>
              <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Quota beccata</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.quote == null?
                'Not disponibile'
                :bet.quote} 
              </Grid.Column>
              </Grid>
          </Table.Cell>                     
          <Table.Cell>
          <Grid columns = {2}>
             <Grid.Column textAlign='center' width = "50%">
              <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Tempo di Risposta</Label>  
              </Grid.Column>
              <Grid.Column floated='left' textAlign='center' width = "50%">
              {bet.answerMs == null?
                'Not available yet'
                :bet.answerMs / 1000} 
              </Grid.Column>
          </Grid>
          </Table.Cell>
          </Table.Row>
          </tbody>
        </Table>
        </div>
      </Segment>
    )
}



class GameControl extends React.Component {
    state = { activeIndex: 0}


    componentDidMount() {
        if (this.props.onMount){
            this.props.onMount(this.props.socket, this.props.user_id, this.props.game_id)
            this.props.getUserPoints(this.props.socket,this.props.user_id)
        }
    }

    componentDidUpdate(prevProps) {
    }

    handleClose = ()  => this.props.closeGameControl();
    handleChange = (e, { activeIndex }) => this.setState({ activeIndex })


    render(){
        const { activeIndex } = this.state
        const {user_id, userPoints} = this.props;
        const panes = []
        panes.push({ menuItem: 'Controllo punti', 
            pane: <Tab.Pane key={''} style={{ height: '100%' }} enabled = {true}>
                {<PointsControl user_id = {user_id} userPoints ={userPoints}/>}  
                </Tab.Pane>})
        
        const keysQ = Object.keys(this.props.question_game)
        const runQ = [];
        for (var k = 0; k < keysQ.length; k++){
            const q = this.props.question_game[keysQ[k]];
            if (q && q.end_bet_date != null)
                runQ[q.position] = q;
        }
        for (var i = 0; (i< runQ.length);i++){
            const s = 'Q'+(i+1);
            let singleA = null
            for (var j = 0; (this.props.bets[user_id]!= null && j< this.props.bets[user_id].length); j++){
                if (runQ[i] != null){
                    if (this.props.bets[user_id][j].question_id == runQ[i].question_id){
                        singleA = this.props.bets[user_id][j];
                        break;
                    }
                }
            }
            if (singleA == null){
                panes.push({ menuItem: s, 
                        pane: <Tab.Pane key={i+1} style={{ height: '100%' }}> 
                            {singleAnswer(null)}
                        </Tab.Pane> })
            }else {
                panes.push({ menuItem: s, 
                        pane: <Tab.Pane key={i+1} style={{ height: '100%' }}> 
                            {singleAnswer(singleA)}
                        </Tab.Pane> })
            }   
        }

        return (
            <div>
                <Tab panes={panes} 
                    activeIndex={activeIndex} 
                    onTabChange={this.handleChange}
                    renderActiveOnly={false}
                    style={{ height: '100%' }} />
                <Button content='Chiudi' fluid negative  onClick={this.handleClose} />
            </div>
        )   
    }
            
}

const mapStateToProps = (state) => ({    
    bets: state.bets,
    socket: state.socket,
    userPoints:state.userPoints,
    question_game: state.question_game
})
 
 const mapDispatchToProps = (dispatch) => ({
    onMount: (socket, user_id, game_id) => dispatch(getBets(socket, user_id, game_id)),
    getUserPoints: (socket,user_id) => dispatch(getUserPoints(socket,user_id))
 })
 
 
 export default connect(
     mapStateToProps,
     mapDispatchToProps
 )(GameControl)


// WEBPACK FOOTER //
// ./src/components/GameControl.js